export default "__VITE_ASSET__BmcKXHJh__"